import React, { FC, useState, useEffect, useRef } from 'react';
import { appStore } from '@store';
import { GetMyPlanBlock, TrialBlock } from './components';
import Description from 'modules/paywall/components/withTimerDesign/description';
import Reviews from 'modules/paywall/components/withTimerDesign/reviews';
import SpecialFeatures from 'modules/paywall/components/specialFeatures';
import StatisticBlock from 'modules/paywall/components/statisticBlock';
import Featured from 'modules/paywall/components/withTimerDesign/featured';
import RealPhotoV2 from 'modules/paywall/components/withTimerDesign/mainScreen/realPhotoV2/realPhotoV2';
import Plan from 'modules/paywall/components/withTimerDesign/plan';
import { useT } from '@hooks';
import * as S from './styled';

interface Props {
	children: React.ReactElement;
}

export const PaywallLayoutWelcomeTrial: FC<Props> = props => {
	const { children } = props;
	const { answers } = appStore.surveyStore;
	const { T } = useT();
	const goalWeight = answers.target_weight?.[0]
		? Number(JSON.parse(answers.target_weight?.[0]).value)
		: 0;
	const currentWeight = answers.weight?.[0] ? Number(JSON.parse(answers.weight?.[0]).value) : 0;

	return (
		<S.Container>
			<S.TrialBlockWrapper>
				<TrialBlock />
			</S.TrialBlockWrapper>
			<S.Padding20>
				{children}
				<GetMyPlanBlock />
			</S.Padding20>
			<S.RealPhotoWrapper>
				<h3>{T('realPhotoV2_subtitle_v2')}</h3>
				<RealPhotoV2 />
			</S.RealPhotoWrapper>
			<S.Padding20>
				<Plan />
			</S.Padding20>
			<SpecialFeatures />
			<S.Padding20>
				<StatisticBlock />
				<Reviews />
				{children}
				<GetMyPlanBlock />
				<Featured />
				<Description />
			</S.Padding20>
		</S.Container>
	);
};
